import { iso } from 'newtype-ts';
export const _ = iso();
